import React, {FC, ReactElement, ReactNode} from 'react'
import styled from 'styled-components'

import {AssetsListProps} from './types'
import {AssetData, AssetType} from '../../../state/rest'
import {ListContainer, SelectableListItemContainer, ListItem} from '../../Atoms/Lists'
import {IconDocument, IconPhoto, IconVideo} from '../../../Assets/Icons/TinyIcons'
import {IconCloseSmall} from '../../../Assets/Icons/TinyIcons'
import {orderBy} from 'lodash'
import {IconButton} from '../../Atoms/Buttons'
import {colors} from '../../../sharedComponents/colors'

const AssetListContainer = styled(ListContainer)`
  max-height: 288px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${colors.system.lightGrey_5};
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.system.grey_4};
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${colors.system.grey_3};
  }

  scrollbar-width: thin;
  scrollbar-color: ${colors.system.grey_4} ${colors.system.lightGrey_5};

  > *:last-child {
    margin-bottom: 0;
  }
`

const AssetListItem = styled(ListItem)``

const AssetListContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: start;
  justify-items: left;
`

const AssetRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`

const AssetsList: FC<AssetsListProps> = (props): ReactElement | null => {
  const assetsOfType = orderBy(
    props.assets.filter(asset => {
      return asset.assetType === props.assetType
    }),
    ['createDateTime'],
    ['desc']
  )

  const getAssetIcon = (type: AssetType): ReactNode => {
    switch (type) {
      case AssetType.DOCUMENT: {
        return <IconDocument />
      }
      case AssetType.PHOTO: {
        return <IconPhoto />
      }
      case AssetType.VIDEO: {
        return <IconVideo />
      }
    }
    return null
  }

  const handleClick = (asset: AssetData) => {
    if (props.onClick) {
      props.onClick(asset)
    }
  }

  return (
    <AssetListContainer>
      {assetsOfType
        ? assetsOfType.map(asset => (
            <SelectableListItemContainer key={`container-${asset.id}`} isSelected={props.selected?.id === asset.id}>
              <AssetListItem icon={getAssetIcon(asset.assetType)} key={asset.id} onClick={() => handleClick(asset)}>
                <AssetRow>
                  <AssetListContent>{asset.name}</AssetListContent>
                  {props.onRemove ? (
                    <IconButton
                      buttonProps={{
                        onClick: e => {
                          e.preventDefault()
                          e.stopPropagation()
                          props.onRemove?.(asset)
                        }
                      }}
                      icon={<IconCloseSmall color={colors.system.grey_1} />}
                    />
                  ) : null}
                </AssetRow>
              </AssetListItem>
            </SelectableListItemContainer>
          ))
        : null}
    </AssetListContainer>
  )
}

export default AssetsList
